import { TooltipItem } from "@/components/Input/types";

type Facility = {
  item: string;
  tooltip: TooltipItem;
};

export const FACILITIES: Facility[] = [
  {
    item: "accommodation",
    tooltip: { text: "Accommodation", position: "top" },
  },
  {
    item: "bar",
    tooltip: { text: "Bar", position: "top" },
  },
  {
    item: "cafe",
    tooltip: { text: "Cafe", position: "top" },
  },
  {
    item: "child-friendly",
    tooltip: { text: "Child friendly", position: "top" },
  },
  {
    item: "parking",
    tooltip: { text: "Parking", position: "top" },
  },
  {
    item: "pet-friendly",
    tooltip: { text: "Pet friendly", position: "top" },
  },
  {
    item: "restaurant",
    tooltip: { text: "Restaurant", position: "top" },
  },
  {
    item: "restrooms",
    tooltip: { text: "Restrooms", position: "top" },
  },
  {
    item: "seating",
    tooltip: { text: "Seating", position: "top" },
  },
  {
    item: "near-public-transport",
    tooltip: { text: "Near public transport", position: "top" },
  },
  {
    item: "taxi",
    tooltip: { text: "Taxi", position: "top" },
  },
  {
    item: "wheelchair-access",
    tooltip: { text: "Wheelchair access", position: "top" },
  },
  {
    item: "wifi",
    tooltip: { text: "Wifi", position: "top" },
  },
];
